import { doMutation } from '../../core-module/util/graphqlHelper';
import { onLogin } from '../../../plugins/vue-apollo';
import { deviceId, isAuthenticatedRole } from '../helpers/authHelper';

export const ssoSignIn = (token) => {
  const mutation = require('../api/mutation/ssoSignIn.gql');
  const variables = {
    input: {
      token,
      deviceId: deviceId(),
    },
  };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      if (isAuthenticatedRole(data?.ssoSignIn?.user?.role)) {
        onLogin(data.ssoSignIn);
        return { data: data.ssoSignIn };
      } else {
        return { error: 'NOT_FOUND' };
      }
    } else if (error) return { error: JSON.stringify(error) };
  });
};
